<template>
    <b-form-group label="Tipe Emas"
        :description="tipeCreate == null ? 'dibuat pada -' : 'dibuat pada ' + tipeCreate"
        class="select-tipe-barang">
        <b-row no-gutters>
            <b-col>
                <StateInputHandler
                    :isLoading="stateTipeEmas.isLoading"
                    :error="stateTipeEmas.error"
                    errorMessage="Gagal memuat tipe emas."
                    @retry="retry"
                >
                    <multiselect name="gadaiKaratEmas" v-model="input.tipeEmas"
                        :options="optTipeEmas" :disabled="!input.merkEmas || optTipeEmas.length == 0"
                        :internal-search="true" :allow-empty="false" deselect-label="" select-label="" label="name"
                        track-by="name" placeholder="-- Please select an option --" />
                        
                    <EmptyStateInput v-if="input.merkEmas && optTipeEmas.length == 0" />
                </StateInputHandler>
            </b-col>

            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ? false : true">
                <b-badge :variant="pdfReadTipe == false ? 'danger' : 'primary'"
                    :hidden="seTipe == null ? true : false" size="sm"
                    @click="$emit('openModalSE',seTipe, 'tipe', pdfReadTipe)" v-b-tooltip.hover
                    title="SE" name="jenisBarangViewBtn">
                    <i class="fa fa-info px-1"></i>
                </b-badge>
            </b-col>
        </b-row>
    </b-form-group>
</template>
<script>
import StateInputHandler from '@/components/common/StateInputHandler'
import EmptyStateInput from '@/components/common/EmptyStateInput'

export default {
    props: {
        input: { required: true },
        optTipeEmas: { required: true },
        tipeCreate: { required: true },
        pdfReadTipe: { required: true },
        seTipe: { required: true },
        stateTipeEmas: { required: false },
    },
    components: {
        StateInputHandler,
        EmptyStateInput
    },
    methods: {
        retry() {
            this.$emit('getTipeEmas')
        }
    }
    // watch: {
    //     'input.tipeEmas': function (newVal) {

    //         if (this.shouldResetSelections == true) {
    //             this.optPromo = []
    //             this.input.promo = []
    //             this.isPromoRetrieved = false
    //         }

    //         this.shouldResetSelections = true

    //         if (newVal == null) { return }

    //         if (newVal != null) {

    //             this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
    //                 let date = null
    //                 if (response.data.createdAt != null) {
    //                     date = response.data.createdAt
    //                     this.tipeCreate = this.$helper.formatTanggalDMY(date)
    //                 } else {
    //                     this.tipeCreate = null
    //                 }
    //                 if (response.data.suratEdaran.length != 0) {
    //                     let suratEdaran = []
    //                     let suratEdaranKondisi = []
    //                     let suratEdaranTahun = []
    //                     for (var se of response.data.suratEdaran) {
    //                         if (se.jenis == null || se.jenis == "tipe") {
    //                             suratEdaran.push(se)
    //                             if (se.isViewSE == "false") {
    //                                 this.pdfReadTipe = false
    //                             }
    //                         }
    //                         if (se.jenis == "kondisi") {
    //                             suratEdaranKondisi.push(se)
    //                             if (se.isViewSE == "false") {
    //                                 this.pdfReadKondisi = false
    //                             }
    //                             this.seKondisiDariMerk = false
    //                         }
    //                         if (se.jenis == "tahun") {
    //                             suratEdaranTahun.push(se)
    //                             if (se.isViewSE == "false") {
    //                                 this.pdfReadTahun = false
    //                             }
    //                         }
    //                     }
    //                     this.seTipe = suratEdaran
    //                     if (suratEdaranKondisi != null && suratEdaranKondisi.length != 0) {
    //                         this.seKondisi = suratEdaranKondisi
    //                     }
    //                     this.seTahun = suratEdaranTahun
    //                     this.showSeKondisi = true
    //                 } else {
    //                     this.seTipe = null
    //                 }

    //                 if (response.data.berat != null) {
    //                     this.input.tipeEmas.berat = response.data.berat
    //                 }
    //             })
    //         }
    //     },
    // }
}
</script>